import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=4e15360a&scoped=true"
import script from "./CardContent.vue?vue&type=script&lang=ts"
export * from "./CardContent.vue?vue&type=script&lang=ts"
import style0 from "./CardContent.vue?vue&type=style&index=0&id=4e15360a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e15360a",
  null
  
)

export default component.exports